import { createContext, useCallback, useRef, ReactNode } from 'react'

type RegisteredHandlers = {
  takeScreenshot?: () => Promise<string>
  startRecording?: () => Promise<boolean>
  stopRecording?: () => Promise<string>
}

type CameraControlContextShape = {
  register: (handlers: RegisteredHandlers) => () => void
}

const CameraControlContext = createContext<CameraControlContextShape>({
  register: () => () => {},
})

export const CameraControlProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const handlersListRef = useRef<RegisteredHandlers[]>([])
  const register = useCallback((handlers: RegisteredHandlers) => {
    handlersListRef.current.push(handlers)
    return () => {
      const idx = handlersListRef.current.indexOf(handlers)
      if (idx >= 0) handlersListRef.current.splice(idx, 1)
    }
  }, [])
  return (
    <CameraControlContext.Provider
      value={{
        register,
      }}
    >
      {children}
    </CameraControlContext.Provider>
  )
}

export default CameraControlContext
